// frontend/packages/business-console/src/services/notificationsService.js
//
// Tenant Console notifications API client (the bell). Talks to the
// /api/v2/notifications console route; business context is attached by the
// @upryzze/services axios interceptor (x-business-id), so callers pass nothing.

import { api } from '@upryzze/services';

// -> { items: [{ _id, message, metadata, read, createdAt }], unread }
export async function getNotifications() {
  const { data } = await api.get('/v2/notifications');
  return data || { items: [], unread: 0 };
}

export async function markNotificationRead(id) {
  const { data } = await api.patch(`/v2/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsRead() {
  const { data } = await api.post('/v2/notifications/read-all');
  return data;
}
